(function() {
    'use strict';

    angular.module('remitEventsApp').controller('FooterController', function($translate) {
        var vm = this;

        vm.getLink = function(type) {
            var language = $translate.use();
            var link = '';

            switch (type) {
                case 'privacyPolicy':
                    link = language === 'pl' ? 'PL/PolitykaPrywatnosci/Strony/default.aspx' : 'EN/PrivacyPolicy/Pages/default.aspx';
                    break;
                case 'legalReservations':
                    link = language === 'pl' ? 'PL/ZastrzezeniaPrawne/Strony/default.aspx' : 'EN/LegalDisclaimer/Pages/default.aspx';
                    break;
                default:
                    link = language === 'pl' ? 'PL/' : 'EN/';
            }

            return 'http://www.orlen.pl/' + link;
        };
    });
})();
